import { NextSeo } from 'next-seo';

import classNames from 'classnames';

import { css } from '@emotion/react';
import { policyWrapper } from '@styles/PolicyStyles';
import { HeaderV2Options } from '@type/web/header';

import AppLayout from '@components/web/Layout/AppLayout';

const PostPolicy = (): JSX.Element => {
  const headerOptions: HeaderV2Options = {
    isFixed: {
      pc: false,
      tablet: true,
    },
    isTopPosition: false,
    isShowBackground: true,
    showAppDownloadBtn: false,
    showNavigationBar: [],
    title: {
      text: '게시글 개인정보 수집 및 이용 동의 사항 안내',
      showTitle: ['mobile', 'tablet', 'desktop'],
    },
  };

  return (
    <AppLayout headerOptions={headerOptions}>
      <NextSeo
        title="중고나라 작성 게시글 개인정보 수집 및 이용 안내"
        description="중고나라 게시글 개인정보 수집 및 이용 안내입니다."
      />
      <main css={{ backgroundColor: '#e1e1e1' }}>
        <div css={policyWrapper}>
          <p className="f13 c_gray">
            중고나라는 사기 방지 및 선량한 이용자 보호, 안전한 서비스 이용환경
            제공을 위해 중고나라 게시판에 게시글 및 댓글 작성시, 아래와 같이
            개인정보를 수집하고 이용합니다. 이용자는 본 동의를 거부할 권리가
            있으나 동의를 거부할 경우 중고나라 게시판의 게시글 및 댓글 작성이
            제한될 수 있습니다. 아래 내용을 상세하게 확인하신 후 게시글 및
            댓글을 작성해 주시기 바랍니다.
          </p>
          <dl
            className={classNames(
              'f13',
              'c_gray',
              'mt20',
              'list_desc',
              'termsCont',
            )}
          >
            <dt className="relative pd_l20">
              <span className="desc">
                <strong>1.</strong>
              </span>
              <p>
                <strong>수집하는 개인정보</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    이용자가 등록한 게시글이 다른 이용자의 신고를 받거나
                    중고나라에 의하여 이상거래로 모니터링 될 경우 이용자가
                    작성하였거나 작성하는 중고나라 게시글 및 댓글에 포함된
                    판매자 연락처 정보(유무선 전화번호 및 네이버, 카카오톡, 구글
                    등의 아이디 등)가 수집됩니다.
                  </p>
                </li>
              </ul>
            </dd>
            <dt className="relative pd_l20 mt10">
              <span className="desc">
                <strong>2.</strong>
              </span>
              <p>
                <strong>수집한 개인정보의 이용</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    제1항에 따라 중고나라가 수집한 개인정보는 이용자들의 사기
                    행위 방지 및 선량한 이용자 보호, 안전한 서비스 이용환경을
                    지원하기 위한 목적(이하 ‘수집·이용 목적’)에서 수집되는
                    것으로, 수집·이용 목적에 필수적인 범위 내에서 활용되며, 그
                    일환으로 수집된 정보가 중고나라 사기통합조회 페이지에 노출될
                    수 있습니다.
                  </p>
                </li>
              </ul>
            </dd>
            <dt className="relative pd_l20 mt10">
              <span className="desc">
                <strong>3.</strong>
              </span>
              <p>
                <strong>개인정보의 보유기간</strong>
              </p>
            </dt>
            <dd className="mt10">
              <ul className="list_desc">
                <li>
                  <p>
                    제1항에 따라 중고나라가 수집한 개인정보는 이용자들의 안전한
                    서비스 이용 환경의 지원과 수집·이용 목적의 달성율을 위해
                    개인정보의 수집 이후 해당 이용자가 다른 이용자의 신고를
                    받거나 중고나라에 의하여 이상거래로 모니터링이 된 마지막
                    날로부터 1년의 범위 내에서 보관되며, 해당 기간이 경과한 경우
                    즉시 파기됩니다. 단, 이용자의 사기통합조회 페이지 내
                    이의제기를 통해 정상회원으로 확인될 경우 수집된 회원정보는
                    즉시 파기합니다.
                  </p>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
        {/* <div css={blank}></div> */}
      </main>
    </AppLayout>
  );
};

export default PostPolicy;

const blank = css`
  width: 100%;
  height: 62px;
  background-color: '#e1e1e1';
`;

const blankInner = css`
  width: 100%;
  height: 62px;
  background-color: '#fff';
  z-index: 10;
`;
